import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border rounded-md border-gray-200 flex flex-col items-start" }
const _hoisted_2 = { class: "editor-menu inline-flex flex-wrap gap-2 p-2" }

import { watch, onBeforeUnmount, ref } from 'vue'
import { useEditor, EditorContent } from '@tiptap/vue-3'
import TextAlign from '@tiptap/extension-text-align'
import StarterKit from '@tiptap/starter-kit'
import Link from '@tiptap/extension-link'
import AddUrlToEditorModalComponent from "@/components/Users/Profile/Modals/AddUrlToEditorModalComponent.vue";
import {
    BoldIcon,
    ItalicIcon,
    StrikethroughIcon,
    ListBulletIcon,
    NumberedListIcon,
    Bars3Icon,
    Bars3BottomLeftIcon,
    Bars3BottomRightIcon,
    LinkIcon,
    LinkSlashIcon
} from "@heroicons/vue/20/solid";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserDescriptionEditor',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const isLinkModalOpen = ref(false)

const editor = useEditor({
    content: props.modelValue,
    extensions: [
        StarterKit.configure({
            codeBlock: false,
            blockquote: false,
        }),
        TextAlign.configure({
            types: ['heading', 'paragraph'],
        }),
        Link.configure({
            autolink: true,
            openOnClick: false
        })
    ],
    onUpdate: ({ editor }) => {
        emit('update:modelValue', editor.getHTML())
    }
})

watch(
    () => props.modelValue,
    (newVal) => {
        if (editor.value && newVal !== editor.value.getHTML()) {
            editor.value.commands.setContent(newVal, false)
        }
    }
)

const addLink = (url: string | null) => {
    if (!editor.value) return
    if (url === null || url === '') {
        editor.value.chain().focus().extendMarkRange('link').unsetLink().run()
    } else {
        editor.value.chain().focus().extendMarkRange('link').setLink({ href: url }).run()
    }

    isLinkModalOpen.value = false
}

onBeforeUnmount(() => {
    editor.value?.destroy()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass({
                    'bg-gray-200': _unref(editor) && _unref(editor).isActive('bold'),
                    'border border-gray-200 px-2 py-1.5 rounded-md text-sm cursor-pointer hover:bg-gray-100': true
                }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(editor) && _unref(editor).chain().focus().toggleBold().run()))
      }, [
        _createVNode(_unref(BoldIcon), { class: "size-4" })
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass({
                    'bg-gray-200': _unref(editor) && _unref(editor).isActive('italic'),
                    'border border-gray-200 px-2 py-1.5 rounded-md text-sm cursor-pointer hover:bg-gray-100': true
                }),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(editor) && _unref(editor).chain().focus().toggleItalic().run()))
      }, [
        _createVNode(_unref(ItalicIcon), { class: "size-4" })
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass({
                    'bg-gray-200': _unref(editor) && _unref(editor).isActive('strike'),
                    'border border-gray-200 px-2 py-1.5 rounded-md text-sm cursor-pointer hover:bg-gray-100': true
                }),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(editor) && _unref(editor).chain().focus().toggleStrike().run()))
      }, [
        _createVNode(_unref(StrikethroughIcon), { class: "size-4" })
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass({
                    'bg-gray-200': _unref(editor) && _unref(editor).isActive('bulletList'),
                    'border border-gray-200 px-2 py-1.5 rounded-md text-sm cursor-pointer hover:bg-gray-100': true
                 }),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(editor) && _unref(editor).chain().focus().toggleBulletList().run()))
      }, [
        _createVNode(_unref(ListBulletIcon), { class: "size-4" })
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass({
                    'bg-gray-200': _unref(editor) && _unref(editor).isActive('orderedList'),
                    'border border-gray-200 px-2 py-1.5 rounded-md text-sm cursor-pointer hover:bg-gray-100': true
                }),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(editor) && _unref(editor).chain().focus().toggleOrderedList().run()))
      }, [
        _createVNode(_unref(NumberedListIcon), { class: "size-4" })
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass({
                    'bg-gray-200': _unref(editor) && _unref(editor).isActive({ textAlign: 'left' }),
                    'border border-gray-200 px-2 py-1.5 rounded-md text-sm cursor-pointer hover:bg-gray-100': true
                }),
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(editor) && _unref(editor).chain().focus().setTextAlign('left').run()))
      }, [
        _createVNode(_unref(Bars3BottomLeftIcon), { class: "size-4" })
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass({
                    'bg-gray-200': _unref(editor) && _unref(editor).isActive({ textAlign: 'center' }),
                    'border border-gray-200 px-2 py-1.5 rounded-md text-sm cursor-pointer hover:bg-gray-100': true
                }),
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(editor) && _unref(editor).chain().focus().setTextAlign('center').run()))
      }, [
        _createVNode(_unref(Bars3Icon), { class: "size-4" })
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass({
                    'bg-gray-200': _unref(editor) && _unref(editor).isActive({ textAlign: 'right' }),
                    'border border-gray-200 px-2 py-1.5 rounded-md text-sm cursor-pointer hover:bg-gray-100': true
                }),
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(editor) && _unref(editor).chain().focus().setTextAlign('right').run()))
      }, [
        _createVNode(_unref(Bars3BottomRightIcon), { class: "size-4" })
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass({
                    'bg-gray-200': _unref(editor) && _unref(editor).isActive('link'),
                    'border border-gray-200 px-2 py-1.5 rounded-md text-sm cursor-pointer hover:bg-gray-100': true
                }),
        onClick: _cache[8] || (_cache[8] = ($event: any) => (isLinkModalOpen.value = true))
      }, [
        (_unref(editor) && _unref(editor).isActive('link'))
          ? (_openBlock(), _createBlock(_unref(LinkSlashIcon), {
              key: 0,
              class: "size-4"
            }))
          : (_openBlock(), _createBlock(_unref(LinkIcon), {
              key: 1,
              class: "size-4"
            }))
      ], 2)
    ]),
    _createVNode(_unref(EditorContent), {
      editor: _unref(editor),
      class: "user-description-editor min-h-30 p-2 border-t border-gray-200 sm:text-sm/6 w-full"
    }, null, 8, ["editor"]),
    _createVNode(AddUrlToEditorModalComponent, {
      open: isLinkModalOpen.value,
      onClose: _cache[9] || (_cache[9] = ($event: any) => (isLinkModalOpen.value = false)),
      onConfirmAction: addLink
    }, null, 8, ["open"])
  ]))
}
}

})